module.exports = __webpack_public_path__ + "img/Cloud.f0bfa30a.png";